import { DATE_HUMAN_FORMAT } from '../../../../../libs/date-utils/constants';
import DateUtils from '../../../../../libs/date-utils/date-utils';

export function formatDatetime(datetime) {
  return DateUtils.format(datetime, DATE_HUMAN_FORMAT);
}
